export default __webpack_public_path__ + "static/media/link3.739dc98d.svg";